import React, {memo, useEffect} from "react";
import {ClockCircleOutlined, UserOutlined} from "@ant-design/icons";
import {Avatar, Empty} from "antd";
import {useNavigate} from "react-router";
import {useAuth0} from "@auth0/auth0-react";
import {useSnapshot} from "valtio/index";
import {HistoryItem, HistoryStore} from "@/utils/store/store";
import {ResultModal} from "@/pages/Index/ResultModal";
import CommonLoading from "@/components/CommonLoading";
import dayjs from "dayjs";
import {VIPStore} from "@/utils/store/vip";
import { supabaseAuthStore } from "@/utils/store/supabaseAuth";

const expandHistory = (contentList:HistoryItem[]) =>{
    return contentList.length  === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className={""} description={"暂无"} /> :
      contentList.map((item, index) => {
          return (
            <div className={"text-[#4B5563] text-sm flex flex-row gap-2"}>
                <ClockCircleOutlined className={"flex-none"}/>

                <div className={"w-24 flex-none"}>
                    {dayjs(item.createTime).format("YYYY-MM-DD")}
                </div>
                <button key={index}
                        className={"font-normal text-sm truncate "}
                     onClick={()=> ResultModal(item)}
                >{JSON.parse(item.result)["default"]}</button>

            </div>
          )
      })
}

interface Props {}

const Index: React.FC<Props> = memo(() => {
    const navigate = useNavigate()
    // 只使用 Supabase 认证状态
    const supabaseAuth = useSnapshot(supabaseAuthStore);
    const { data: historyData,runFetch, isLoading } = useSnapshot(HistoryStore);
    const { data: vipData, runFetch: VIPRunFetch  } = useSnapshot(VIPStore);
    const historyLoading = supabaseAuth.isLoading || isLoading;

    useEffect(() => {
        if(supabaseAuth.isAuthenticated && supabaseAuth.id){
            runFetch(supabaseAuth.id);
        }
    }, [supabaseAuth.isAuthenticated, supabaseAuth.id, runFetch]);

    console.log(46, supabaseAuth.user, supabaseAuth.isLoading, isLoading);
    console.log(50, vipData);

    let vipNotice = "已过期"
    let vipTypeNotice = "体验会员"
    let expireNotice = 0
    if(vipData?.productTypeCur != null && vipData.expireTimeCur != null){
        vipNotice = dayjs.unix(vipData.expireTimeCur).format("YYYY-MM-DD")
        expireNotice = Math.ceil((vipData.expireTimeCur - dayjs().unix()) / 3600 / 24);
        vipTypeNotice = vipData.productTypeCur
    }
    // console.log(51, Object.keys(vipData));

    return <div className={"bg-[#F9FAFB] p-6 flex flex-col gap-8"}>
        <div className="card bg-white border-0 w-[796px] self-center shadow-xs">
            <div className="card-body p-6">

                <div className={"flex flex-col gap-2"}>
                    {
                      supabaseAuth.isLoading? <CommonLoading/>
                    : <div className={"flex flex-row gap-5"}>
                        <Avatar size={64} icon={<UserOutlined />} />
                        <div className={"flex flex-col gap-2"}>
                            <p className={"text-xl font-bold"}>{supabaseAuth.user?.user_metadata?.full_name || supabaseAuth.user?.email}</p>
                            <p className={"text-[#6B7280]"}>UID：{supabaseAuth.id}</p>
                            <p className={"text-[#6B7280]"}>邮箱：{supabaseAuth.user?.email}</p>
                        </div>
                    </div>
                    }
                    {/*<div className="divider mt-5 mb-5"></div>*/}
                    {/*<div className={"flex flex-col gap-2"}>*/}
                    {/*    <p className=" text-[18px]">基本信息</p>*/}
                    {/*    <div className={"grid grid-cols-7"}>*/}
                    {/*        <div className={"col-span-4 flex text-[#4B5563] text-sm self-center"}>*/}
                    {/*            <MailOutlined className={"m-1 mr-2"}/>*/}
                    {/*            <div className={""}>邮箱：test-0001@test.com</div>*/}
                    {/*        </div>*/}
                    {/*        <button className="btn btn-neutral  btn-sm h-6 col-span-1 col-start-10">修改</button>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="divider mt-4 mb-4"></div>
                    <div className={"flex flex-col gap-2"}>
                        <p className=" text-[18px]">最近历史(近7天)</p>
                        {
                            historyLoading ? <CommonLoading/> :
                              expandHistory(historyData[0])
                        }
                    </div>

                </div>
            </div>
        </div>

        <div className="card bg-white border-0 w-[796px]  self-center shadow-xs">
            <div className="card-body p-6">

                <div className={"flex flex-col gap-5"}>
                    <div className={"grid grid-cols-10"} >
                        <div className={"text-[18px] col-span-2"}>会员信息</div>
                        <button className="btn btn-sm h-6 w-18 col-span-1 col-start-10 border-0 text-xs text-[#854D0E] bg-[#FEFCE8]">
                            {vipTypeNotice}
                        </button>
                    </div>
                    <div className={"flex flex-row gap-5"}>

                        <div className="card bg-[#E5E7EB] border-0 w-[896px]">
                            <div className="card-body p-6">
                                <div className={"flex flex-col gap-2"}>
                                    <div className={"text-sm text-[#6B7280]"}>会员有效期</div>
                                    <div className={"flex flex-row gap-2 items-center"}>
                                        <div className={"text-2xl font-bold"}>剩余 {expireNotice} 天</div>
                                        {vipTypeNotice == '体验会员' && <button
                                            className="btn btn-sm h-6 w-18 col-span-1 col-start-10 border-0 text-xs text-[#854D0E] bg-[#FEFCE8]">
                                            限时免费
                                        </button>}
                                    </div>
                                    {/*<div className={"text-sm text-[#6B7280]"}>到期时间：9999-99-99</div>*/}
                                    <div className={"text-sm text-[#6B7280]"}>到期时间：{vipNotice}</div>
                                </div>
                            </div>
                        </div>
                        <div className="card bg-[#E5E7EB] border-0 w-[896px]">
                            <div className="card-body p-6">
                                <div className={"flex flex-col gap-2"}>
                                    <div className={"text-sm text-[#6B7280]"}>本月转写额度</div>
                                    <div className={"flex flex-row gap-2 items-center"}>
                                        <div className={"text-2xl font-bold"}>已用 ∞/∞ 小时</div>
                                        <button className="btn btn-sm h-6 w-18 col-span-1 col-start-10 border-0 text-xs text-[#854D0E] bg-[#FEFCE8]">
                                            限时免费
                                        </button>
                                    </div>
                                    <progress className="progress progress-success w-full" value="50" max="100"></progress>
                                </div>
                            </div>
                        </div>

                    </div>
                    <button className="btn btn-neutral w-full "
                            onClick={() => {
                                // message.info("id:" + user?.email);
                                // window.open("/charge/default")
                                navigate('/charge/default')
                            }}
                    >立即续费</button>

                </div>
            </div>
        </div>

    </div>
    // const [session, setSession] = useState(null)
    // useEffect(() => {
    //     // if(!session){
    //     //     return;
    //     // }
    //     supabase.auth.getSession().then(({ data: { session } }) => {
    //         setSession(session)
    //     })
    //     const {
    //         data: { subscription },
    //     } = supabase.auth.onAuthStateChange((_event, session) => {
    //         setSession(session)
    //     })
    //     return () => subscription.unsubscribe()
    // }, [])
    // if (!session) {
    //     return (<Auth supabaseClient={supabase} appearance={{ theme: ThemeSupa }} />)
    // }
    // else {
    //     return (<div>Logged in!</div>)
    // }
})
Index.displayName = 'Index'

export default Index
